import { render, staticRenderFns } from "./BuyApiCloudPopUp.vue?vue&type=template&id=00954d5a"
import script from "./BuyApiCloudPopUp.vue?vue&type=script&lang=js"
export * from "./BuyApiCloudPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports